import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { TemplateSelection } from './templateSelection';

const TemplateSelectionContext = createContext<{
  selection: TemplateSelection;
  setSelection: (selection: TemplateSelection) => void;
} | null>(null);

export const TemplateSelectionProvider = ({
  locationKey,
  children,
}: {
  locationKey: string | undefined;
  children: ReactNode;
}) => {
  const [state, setState] = useState<{
    locationKey: string | undefined;
    selection: TemplateSelection;
  }>({
    locationKey,
    selection: {},
  });

  useEffect(() => {
    setState((previous) =>
      previous.locationKey === locationKey ? previous : { locationKey, selection: {} },
    );
  }, [locationKey]);

  return (
    <TemplateSelectionContext.Provider
      value={{
        selection: state.locationKey === locationKey ? state.selection : {},
        setSelection: (selection) => {
          setState({ locationKey, selection });
        },
      }}
    >
      {children}
    </TemplateSelectionContext.Provider>
  );
};

export const useTemplateSelection = () => {
  const context = useContext(TemplateSelectionContext);

  if (!context) throw new Error('TemplateSelectionProvider is required');

  return context;
};
